import React from 'react';
import { LayoutDashboard, History, ScrollText, FileText, Database, MessageSquare, Plug } from 'lucide-react';
import AppShell from './AppShell';

const NAV_ITEMS = [
  { label: 'Dashboard', path: '/super-admin/dashboard', icon: LayoutDashboard },
  { label: 'Activity Timeline', path: '/super-admin/timeline', icon: History },
  { label: 'All Logs', path: '/super-admin/logs', icon: ScrollText },
  { label: 'Exams', path: '/super-admin/exams', icon: FileText },
  { label: 'Database Explorer', path: '/super-admin/database', icon: Database },
  { label: 'Query Chat', path: '/super-admin/chat', icon: MessageSquare },
  { label: '3rd Party', path: '/super-admin/third-party', icon: Plug },
];

const SuperAdminLayout = () => (
  <AppShell
    variant="sidebar"
    chromeTone="dark"
    contentTone="dark"
    navItems={NAV_ITEMS}
    roleLabel="SUPER ADMIN"
  />
);

export default SuperAdminLayout;
